import { z } from 'zod';
import { DecimalLikeSchema, IsoDateTimeSchema, PaginationSchema, UuidSchema } from './common.js';
// Estado derivado do cliente/suscrição (não persistido — calculado a partir das cuotas).
export const SubscriptionEstadoSchema = z.enum(['al_dia', 'vencida']);
export const SubscriptionSchema = z.object({
    id: UuidSchema,
    clienteId: UuidSchema,
    montoMensual: DecimalLikeSchema.nullable(),
    fechaVencimiento: IsoDateTimeSchema.nullable(),
    createdAt: IsoDateTimeSchema.nullable(),
    // Derivado pelo backend em list/get; ausente em respostas que não o calculam.
    estado: SubscriptionEstadoSchema.optional(),
});
export const CreateSubscriptionRequestSchema = z.object({
    clienteId: UuidSchema,
    montoMensual: DecimalLikeSchema.nullable().optional(),
    fechaVencimiento: IsoDateTimeSchema.nullable().optional(),
});
export const UpdateSubscriptionRequestSchema = z.object({
    montoMensual: DecimalLikeSchema.nullable().optional(),
    fechaVencimiento: IsoDateTimeSchema.nullable().optional(),
});
export const SubscriptionListQuerySchema = PaginationSchema.extend({
    clienteId: UuidSchema.optional(),
});
export const SuscripcionesDashboardSchema = z.object({
    totalActivas: z.number().int().nonnegative(),
    ingresoProyectado: DecimalLikeSchema,
    vencidas: z.number().int().nonnegative(),
    proximas7d: z.number().int().nonnegative(),
});
export const PaymentHistorySchema = z.object({
    id: UuidSchema,
    clienteId: UuidSchema.nullable(),
    subscriptionId: UuidSchema.nullable(),
    monto: DecimalLikeSchema.nullable(),
    fechaPago: IsoDateTimeSchema.nullable(),
    metodoPago: z.string().max(100).nullable(),
    estado: z.string().max(50).nullable(),
    createdAt: IsoDateTimeSchema.nullable(),
});
export const CreatePaymentHistoryRequestSchema = z.object({
    subscriptionId: UuidSchema.nullable().optional(),
    clienteId: UuidSchema.nullable().optional(),
    monto: DecimalLikeSchema.nullable().optional(),
    fechaPago: IsoDateTimeSchema.optional(),
    metodoPago: z.string().max(100).nullable().optional(),
    estado: z.string().max(50).nullable().optional(),
});
export const UpdatePaymentHistoryRequestSchema = z.object({
    monto: DecimalLikeSchema.nullable().optional(),
    fechaPago: IsoDateTimeSchema.optional(),
    metodoPago: z.string().max(100).nullable().optional(),
    estado: z.string().max(50).nullable().optional(),
});
export const PaymentHistoryListQuerySchema = PaginationSchema.extend({
    subscriptionId: UuidSchema.optional(),
    clienteId: UuidSchema.optional(),
    from: IsoDateTimeSchema.optional(),
    to: IsoDateTimeSchema.optional(),
});
// Estado de cada cuota do cronograma.
export const PaymentScheduleEstadoSchema = z.enum(['pendiente', 'cobrada', 'vencida']);
export const PaymentScheduleSchema = z.object({
    id: UuidSchema,
    subscriptionId: UuidSchema,
    fechaVencimiento: IsoDateTimeSchema.nullable(),
    monto: DecimalLikeSchema.nullable(),
    periodo: z.string().max(7).nullable(),
    estado: z.string().max(50).nullable(),
    fechaCobro: IsoDateTimeSchema.nullable(),
    createdAt: IsoDateTimeSchema.nullable(),
});
export const CreatePaymentScheduleRequestSchema = z.object({
    subscriptionId: UuidSchema,
    fechaVencimiento: IsoDateTimeSchema.nullable().optional(),
    monto: DecimalLikeSchema.nullable().optional(),
    periodo: z.string().max(7).nullable().optional(),
    estado: z.string().max(50).nullable().optional(),
});
export const PaymentScheduleListQuerySchema = PaginationSchema.extend({
    subscriptionId: UuidSchema.optional(),
});
// "Generar plan de pago": gera N cuotas a partir de uma fecha de início, com
// periodicidade e monto fixo por cuota. O motor de cuotas (PaymentSchedule) já existe;
// este request parametriza a geração em lote.
export const PeriodicidadSchema = z.enum(['mensual', 'trimestral', 'anual']);
export const GenerarPlanRequestSchema = z.object({
    periodicidad: PeriodicidadSchema,
    numCuotas: z.number().int().positive().max(120),
    fechaInicio: IsoDateTimeSchema,
    monto: DecimalLikeSchema,
});
//# sourceMappingURL=suscripciones.js.map